import React from "react";

const renderCursoOptions = (cursos = [], loading) => {
  if (loading) {
    return <option value="all">Cargando...</option>;
  }
  if (!cursos.length) {
    return <option value="all">Sin cursos disponibles</option>;
  }
  return [
    <option key="all" value="all">
      Todos
    </option>,
    ...cursos.map((curso) => (
      <option key={curso.id} value={curso.id}>
        {curso.nombre}
      </option>
    )),
  ];
};

export default function PromocionesFilters({
  filtros,
  setFiltros,
  limpiarFiltros,
  estadoOptions = [],
  cursos = [],
  cursosLoading = false,
}) {
  return (
    <div className="management-card promociones-filters-card management-filters-card mb-4">
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-3">
          <label className="form-label management-label mb-1">Buscar</label>
          <input
            type="search"
            className="form-control"
            placeholder="Promoción, curso o convocatoria"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Activo</label>
          <select
            className="form-select"
            value={filtros.activo}
            onChange={(e) => setFiltros((prev) => ({ ...prev, activo: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="1">Activas</option>
            <option value="0">Inactivas</option>
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Curso</label>
          <select
            className="form-select"
            value={filtros.curso_id}
            onChange={(e) => setFiltros((prev) => ({ ...prev, curso_id: e.target.value }))}
            disabled={cursosLoading}
          >
            {renderCursoOptions(cursos, cursosLoading)}
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label mb-1">Estado</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.estado}
              onChange={(e) => setFiltros((prev) => ({ ...prev, estado: e.target.value }))}
            >
              <option value="all">Todos</option>
              {estadoOptions.map((estado) => (
                <option key={estado.value} value={estado.value}>
                  {estado.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser-fill me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}




